var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-navigation-tabs", {
        staticClass: "mb-2",
        attrs: { items: _vm.links }
      }),
      _c("router-view", { attrs: { "customer-data": _vm.customerData } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }